//
// Generated class OnlineProduct
//

/// <reference path="OnlineProduct_ManagedObject.ts" />

class OnlineProduct extends OnlineProduct_ManagedObject
{

}
